import React from 'react'
import MetaWrapper from '@components/Meta/MetaWrapper'
import Page from './Page'
import { useTranslation } from 'react-i18next'
import { useBlogArticleQuery } from '@graphql/queries/__generated__/blog.generated'
import { useParams } from 'react-router-dom'
import { getBlogArticleUrl } from '../../../urls'

const View: React.FC = () => {
  const { t } = useTranslation()
  const { blogSlug, articleSlug } = useParams<{ blogSlug: string; articleSlug: string }>()
  const articleQueryResult = useBlogArticleQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: { slug: articleSlug },
  })

  return (
    <MetaWrapper
      titleDetails={t('metaTitle.wholesaleBlog', 'Wholesale Blog')}
      meta={{
        custom: [
          <link
            key='product:canonical'
            rel='canonical'
            href={window.location.origin + getBlogArticleUrl(blogSlug, articleSlug)}
          />,
        ],
      }}
    >
      <Page articleQueryResult={articleQueryResult} blogSlug={blogSlug} />
    </MetaWrapper>
  )
}

export default View
